// extracted by mini-css-extract-plugin
export var dismiss = "style-module--dismiss--73555";
export var dropdown = "style-module--dropdown--fa46c";
export var flag = "style-module--flag--56d79";
export var info = "style-module--info--fb17f";
export var modal = "style-module--modal--86f80";
export var switcher = "style-module--switcher--03911";